<template>
  <div class="ads">
    <div v-if="images[0]" class="acima">
      <a >
        <img :src='isMobile ? url+images[0].mobile.imageUrl : url+images[0].desktop.imageUrl' :alt="images[0].desktop.name">
      </a>
    </div>
    <div class="abaixo">
      <a v-if="images[1]">
        <img :src='isMobile ? url+images[1].mobile.imageUrl : url+images[1].desktop.imageUrl' :alt="images[1].desktop.name">
      </a>
    </div>
  </div>
</template>

<script>
import {baseUrl} from '../helpers/helpers'
export default {
  name: 'rightColumnAds',
  data(){
    return{
      url:baseUrl,
      isMobile: window.innerWidth <= 992
    }
  },
  props: {
    images:{
      type:Array,
      default:function(){
        return []
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/rightColumnAds.scss";
</style>
